var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.raw_fields.type == 'BPInlineBoxData')?_c('DataInline',{attrs:{"parsed_fields":_vm.parsed_fields,"raw_fields":_vm.raw_fields,"readonly":_vm.readonly,"lang":_vm.lang,"is_mobile":_vm.is_mobile,"json":_vm.json},on:{"update":_vm.update}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }